
  export default {
    name: 'CustomerSuccessStoriesList',
    props: {
      slice: {
        type: Object,
        required: true,
        default() {
          return {}
        },
      },
    },
    data() {
      return {
        showMore: false,
      }
    },
    computed: {
      formattedCards() {
        return this.slice.items.map((item) => {
          const title = this.$prismic.asText(item.title)
          return {
            title: title,
            image: item.image,
            description: item.description,
            link: item.link,
          }
        })
      },
      firstFour() {
        return this.formattedCards ? this.formattedCards.slice(0, 4) : []
      },
      overflow() {
        let cardLength = this.formattedCards.length
        if (cardLength > 4) {
          return this.formattedCards.slice(5, cardLength)
        }
        return []
      },
    },
  }
